<script lang="ts">
</script>

<thead>
    <tr>
        <th style="width:35%">Adresse</th>
        <th style="width:35%">Stadt</th>
        <th style="width:15%">PLZ</th>
        <th style="width:15%">Status</th>
    </tr>
</thead>

<style>
    th {
        position: sticky;
        top: 0;
        background-color: white;
        box-shadow: 1px 2px 2px 0px rgb(0 0 0 / 40%);
        text-align: center !important;
    }
</style>
